module.exports = __webpack_public_path__ + "img/239c0f4.png";